// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".bundle." + {"61":"02a366fce3d0ad21379c","531":"fcb101520e44ae226855","664":"95485f4eef1ecdb4f2ab","942":"2a97d98cb8533f8d7fd6"}[chunkId] + ".js";
};